import React from 'react';
import PropTypes from 'prop-types';
import MaxWidthContainer from '../Global/Containers/MaxWidthContainer';
import LargeSearch from '../Search/LargeSearch';
import TrendingSearches from '../Search/TrendingSearches';

const TrainingGroundHero = ({ heroImage, orgName, quote, trendingResults, trendingLoading, ...rest }) => {
  return (
    <section 
      className="training-ground-hero hero hero--l fade-overlay-new d-flex align-items-center color-white background-size-cover"
      style={{
        backgroundImage: `url(${heroImage})`,
        // Hack to prevent Gerrard's head being cropped on Rangers platform
        backgroundPosition: (orgName === `Rangers Football Club` || orgName === `Southampton FC`) && `center top`,
      }}
    >
      <MaxWidthContainer classes="w-100">
        <div className="max-width-s m-x-auto fade-overlay__inner">
          <h1 className="like-h1 m-b-2">{orgName}</h1>
          {quote &&
            <p className="training-ground-hero__quote hidden-sm-down d-inline-block like-h5 m-b-3 p-a-1 border-radius-l">{quote}</p>
          }
          <LargeSearch {...rest} />
          {trendingResults && trendingResults.length > 0 &&
            <TrendingSearches icon titleClasses="hidden-sm-down like-h5 m-b-0" loading={trendingLoading} results={trendingResults} linkClass="link--white" />
          }
        </div>
      </MaxWidthContainer>
    </section>
  );
};

TrainingGroundHero.propTypes = {
  heroImage: PropTypes.string,
  quote: PropTypes.string,
  orgName: PropTypes.string,
  trendingResults: PropTypes.array,
  trendingLoading: PropTypes.bool,
};

export default TrainingGroundHero;



// WEBPACK FOOTER //
// ./library/app/components/TrainingGround/TrainingGroundHero.js